import { EmojiButton } from '@joeattardi/emoji-button';
const picker = new EmojiButton();

var inputTarget = ""

const buttons = document.querySelectorAll('.emoji-button');
buttons.forEach(button => {
    button.addEventListener('click', (e) => {
        e.preventDefault();

        let btn = e.path.find(path => path.id.includes('button-emoji'));
        if (!btn) {
            console.error("Emoji Error")
            return;
        }
        inputTarget = btn.id.replace('button-emoji-', 'input-');
        if (!inputTarget) {
            console.error('Emoji Error');
            return;
        }
        picker.togglePicker(button);
    });
});

picker.on('emoji', selection => {
    if (!inputTarget) {
        console.error('Emoji Error');
        return;
    }
    document.querySelector("#" + inputTarget).value += selection.emoji;
});